/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { computed } from '@ember/object';
import { notEmpty } from '@ember/object/computed';
import { all, any } from 'cio/app-models/conditions/group';
import PageviewCondition from 'cio/app-models/conditions/pageview';
import CioConditionViewerBase, { CioConditionViewerBaseArgs } from 'cio/components/cio-condition-viewer-base';

const GROUP_TYPES = {
  [all]: 'all',
  [any]: 'at least one',
};

interface CioConditionViewerPageviewArgs extends CioConditionViewerBaseArgs {
  condition: PageviewCondition;
}

export default class CioConditionViewerPageview extends CioConditionViewerBase<CioConditionViewerPageviewArgs> {
  @notEmpty('args.condition.filters') hasFilter!: boolean;

  @computed('args.condition.filterOperator')
  get filterOperator() {
    return GROUP_TYPES[this.args.condition.filterOperator];
  }
}
